import React from 'react';

export default function VehicleOverlay() {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none" style={{ top: '5%', bottom: '25%', left: '10%', right: '10%' }}>
      <div className="w-full h-full border-2 border-white/30 rounded-lg relative">
        {/* Corner marks */}
        <div className="absolute -top-0.5 -left-0.5 w-8 h-8 border-t-[3px] border-l-[3px] border-white/70 rounded-tl-lg" />
        <div className="absolute -top-0.5 -right-0.5 w-8 h-8 border-t-[3px] border-r-[3px] border-white/70 rounded-tr-lg" />
        <div className="absolute -bottom-0.5 -left-0.5 w-8 h-8 border-b-[3px] border-l-[3px] border-white/70 rounded-bl-lg" />
        <div className="absolute -bottom-0.5 -right-0.5 w-8 h-8 border-b-[3px] border-r-[3px] border-white/70 rounded-br-lg" />
        {/* Center crosshair */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-6 h-[1px] bg-white/25" />
          <div className="absolute h-6 w-[1px] bg-white/25" />
        </div>
      </div>
    </div>
  );
}
